import type { Idl } from "@coral-xyz/anchor";
import { AnchorProvider, Program } from "@coral-xyz/anchor";
import { useConnection } from "@solana/wallet-adapter-react";
import type { Connection } from "@solana/web3.js";
import { PublicKey } from "@solana/web3.js";
import { readOnlyAnchorWallet } from "@stepfinance/common";
import { useEffect, useState } from "react";

import { CONFIRM_OPTIONS } from "../utils/network";
import type { ConnectedWallet } from "./wallet/useConnectedWallet";
import { useConnectedWallet } from "./wallet/useConnectedWallet";

export const makeProgram = <T extends Idl>(
  connection: Connection,
  programAddress: string,
  IDL: T,
  wallet: ConnectedWallet | undefined,
) => {
  const userWallet = wallet ? wallet : readOnlyAnchorWallet;

  const provider = new AnchorProvider(connection, userWallet, CONFIRM_OPTIONS);
  const program = new Program(IDL, new PublicKey(programAddress), provider);

  return program;
};

export const useAnchorProgram = <T extends Idl>(IDL: T, programAddress: string): Program<T> | undefined => {
  const { connection } = useConnection();
  const wallet = useConnectedWallet();
  const [program, setProgram] = useState<Program<T>>();

  useEffect(() => {
    const program = makeProgram(connection, programAddress, IDL, wallet);
    setProgram(program);
  }, [IDL, connection, programAddress, wallet]);

  return program;
};
